import React, { useState } from "react";
import { Copy, Check, Terminal, MapPin, CheckCircle2 } from "lucide-react";

// Renders the "how to verify" checks attached to a runbook task:
// each entry is a CLI command to copy or a UI navigation path, plus the good-output.
export const TaskChecks = ({ checks = [], testId }) => {
  if (!checks.length) return null;
  return (
    <div className="sm:col-span-2 mt-1" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-widest text-emerald-400 font-semibold mb-2">
        How to verify — command & where to run
      </div>
      <div className="space-y-2">
        {checks.map((c, i) => (
          <CheckLine key={i} check={c} idx={i} />
        ))}
      </div>
    </div>
  );
};

const CheckLine = ({ check, idx }) => {
  const [copied, setCopied] = useState(false);
  const isCli = check.kind === "cli";
  const copy = () => {
    navigator.clipboard.writeText(check.cmd);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="rounded-md border border-zinc-800 bg-black overflow-hidden">
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-zinc-800 bg-zinc-950">
        <span className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">
          {isCli ? <Terminal className="h-3 w-3 text-blue-500" /> : <MapPin className="h-3 w-3 text-amber-500" />}
          {check.where}
        </span>
        {isCli && (
          <button
            onClick={copy}
            data-testid={`copy-check-${idx}`}
            className="no-print flex items-center gap-1 text-[11px] text-zinc-400 hover:text-white transition-colors"
          >
            {copied ? <Check className="h-3 w-3 text-emerald-500" /> : <Copy className="h-3 w-3" />}
            {copied ? "Copied" : "Copy"}
          </button>
        )}
      </div>
      <div className={`px-3 py-2.5 font-mono text-[13px] whitespace-pre-wrap break-all ${isCli ? "text-emerald-300" : "text-amber-200"}`}>
        {isCli ? <span className="text-zinc-600 select-none">$ </span> : <span className="text-zinc-600 select-none">→ </span>}
        {check.cmd}
      </div>
      {check.good && (
        <div className="px-3 py-1.5 border-t border-zinc-900 text-[12px] text-zinc-400 font-sans flex items-start gap-1.5">
          <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500 shrink-0 mt-0.5" />
          <span><span className="text-zinc-500">Good:</span> {check.good}</span>
        </div>
      )}
    </div>
  );
};
